export const SCHEDULE_WITH_CONTACT_PROVIDER = {
  PARENT_COMPONENT: {
    CONTACT_PROFILE: 'CONTACT_PROFILE',
    CONTACT_LIST: 'CONTACT_LIST',
    MEETINGS_PAGE: 'MEETINGS_PAGE',
  }
}
